import React from "react";

export const ModalTab3 = () => {
  return (
    <>
      <h2>매출조회</h2>
    </>
  );
};
